export default __webpack_public_path__ + "static/media/phone.5b338c09.svg";